import { render, staticRenderFns } from "./RestoreRequest.vue?vue&type=template&id=4e760dbc&scoped=true"
import script from "./RestoreRequest.vue?vue&type=script&lang=js"
export * from "./RestoreRequest.vue?vue&type=script&lang=js"
import style0 from "./RestoreRequest.vue?vue&type=style&index=0&id=4e760dbc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e760dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e760dbc')) {
      api.createRecord('4e760dbc', component.options)
    } else {
      api.reload('4e760dbc', component.options)
    }
    module.hot.accept("./RestoreRequest.vue?vue&type=template&id=4e760dbc&scoped=true", function () {
      api.rerender('4e760dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/RestoreRequest.vue"
export default component.exports